<div
  *ngIf="loading"
  class="loading-spinner"
  [ngClass]="fullScreen ? 'full-screen' : 'not-full-screen'"
  [ngSwitch]="type"
>
  <div class="loading" *ngSwitchCase="'icon'">
    <div class="circle">
      <svg width="16px" height="12px">
        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
      </svg>
      <svg width="16px" height="12px">
        <polyline  id="back"  points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
      </svg>
    </div>
  </div>

  <div *ngSwitchCase="'string'">
    <div class="loading waiting">
      <p class="waiting-text">{{ message }}</p>
    </div>
  </div>
</div>
